import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

export default function RecuperarSenha() {
  const [email, setEmail] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setErro('');
    try {
      await api.post('/auth/recuperar-senha', { email });
      setEnviado(true);
    } catch {
      setErro('Não foi possível enviar o e-mail. Tente novamente.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-primary flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8">
        <div className="text-center mb-8">
          <img src="/logo-inbase.png" alt="Inbase Construtora" className="h-16 w-auto mx-auto mb-3" />
          <p className="text-gray-500 text-sm">Recuperação de senha</p>
        </div>

        {enviado ? (
          <div className="text-center space-y-4">
            <div className="text-green-600 text-4xl">✓</div>
            <p className="text-gray-700 text-sm">
              Se esse e-mail estiver cadastrado, você receberá um link para redefinir sua senha em breve.
            </p>
            <Link to="/login" className="block text-secondary text-sm hover:underline">
              Voltar para o login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <p className="text-gray-600 text-sm">
              Informe seu e-mail cadastrado e enviaremos um link para redefinir sua senha.
            </p>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">E-mail</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-secondary"
                placeholder="seu@email.com"
                required
              />
            </div>
            {erro && <p className="text-danger text-sm">{erro}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-primary text-white py-3 rounded-lg font-semibold hover:bg-secondary transition-colors disabled:opacity-50"
            >
              {loading ? 'Enviando...' : 'Enviar link de recuperação'}
            </button>
            <Link to="/login" className="block text-center text-sm text-gray-500 hover:underline">
              Voltar para o login
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
